import { TAppMaster } from '@monorepo/resolvers';
import * as _ from 'lodash';
import { normalize, schema } from 'normalizr';
import { TAppMasterDatabase } from './app-master-db.reducer';

export enum AppMasterDBTypes {
  APP_MASTER = 'APP_MASTER',
  APPS = 'APPS',
  MODULES = 'MODULES',
  VIEW_DESCRIPTORS = 'VIEW_DESCRIPTORS',
  BUSINESS_CONTEXT = 'BUSINESS_CONTEXT',
  SUBJECTS = 'SUBJECTS',
}

const subjects = new schema.Entity(AppMasterDBTypes.SUBJECTS, undefined, {
  idAttribute: (value: TAppMaster['apps'][0]['settingInfo']['subjects'][0]) => value.subject,
});

const business_context = new schema.Entity(AppMasterDBTypes.BUSINESS_CONTEXT, undefined, {
  idAttribute: (value: TAppMaster['apps'][0]['settingInfo']['bctx'][0]) => value.bctx_type,
});

const view_descriptors = new schema.Entity(AppMasterDBTypes.VIEW_DESCRIPTORS, undefined, {
  idAttribute: (value: TAppMaster['apps'][0]['appInfo']['modules'][0]['view_descriptors'][0]) => value.view_name,
});

const modules = new schema.Entity(
  AppMasterDBTypes.MODULES,
  {
    view_descriptors: [view_descriptors],
  },
  {
    idAttribute: (value: TAppMaster['apps'][0]['appInfo']['modules'][0]) => value.module_type,
  },
);

const apps = new schema.Entity(
  AppMasterDBTypes.APPS,
  {
    appInfo: {
      modules: [modules],
    },
    settingInfo: {
      subjects: [subjects],
      bctx: [business_context],
    },
  },
  {
    idAttribute: (value: TAppMaster['apps'][0]) => value.appInfo.app_id,
  },
);

const appMaster = new schema.Entity(
  AppMasterDBTypes.APP_MASTER,
  {
    apps: [apps],
  },
  {
    idAttribute: (value) => value.clientInfo.subject_key,
  },
);

// const normalizedData = normalize(data, [ list ]);
export const getNormalizedData = (originalData: TAppMaster) => {
  const normalizedAppMaster = normalize(originalData, appMaster);

  return {
    ...normalizedAppMaster,
    originalAppMasterDb: originalData,
  } as TAppMasterDatabase;
};
